module.exports = __webpack_public_path__ + "static/media/stirring-pots.1463724f.png";